import type { ReactNode } from "react";
import { useMemo } from "react";

import type { LinkContextValue } from "./context";
import { LinkContext } from "./context";

export interface ILinkProviderProps extends LinkContextValue {
    children: ReactNode;
}

export const LinkProvider = ({ linkFn, children }: ILinkProviderProps) => {
    const value = useMemo(() => ({ linkFn }), [linkFn]);

    return <LinkContext.Provider value={value}>{children}</LinkContext.Provider>;
};
